import { Loader2 } from 'lucide-react'
import { getStateMeta } from './stateMeta'
import type { ZanshinPair } from '@/services/zanshin.service'
import { PENDING_AGE_AMBER_S, PENDING_AGE_RED_S } from '@/services/zanshin.service'

/**
 * Badge atomico inline per visualizzare lo stato Zanshin di una singola pair.
 * Pensato per OpenPositionsPanel (badge inline accanto a HEDGED/PROP ONLY).
 *
 * Spec: solo icona + label + colore bordo. NIENTE dettaglio espandibile.
 * Pending: piccolo spinner + cambio colore bordo (no overlay separato).
 *
 * Compatto: h-6 (24px), padding orizzontale 8px, font-size 11px.
 */
export function ZanshinStateBadge({ pair }: { pair: ZanshinPair }) {
  const op = pair.operation
  const meta = getStateMeta(op?.zanshin_state ?? null, op?.shield_phase ?? 0)

  // Pending color override (rosso se >12s, giallo se >6s)
  const pendingAge = op?.pending_age_s ?? null
  const isPending = op?.is_pending ?? false
  const pendingClass =
    !isPending || pendingAge === null ? '' :
    pendingAge > PENDING_AGE_RED_S   ? 'border-red-500 ring-1 ring-red-500/40' :
    pendingAge > PENDING_AGE_AMBER_S ? 'border-amber-500 ring-1 ring-amber-500/40' :
    'border-amber-500/60'

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 h-6 rounded-md text-[11px] font-medium border ${meta.bg} ${meta.text} ${pendingClass || meta.border}`}
      title={isPending && pendingAge !== null
        ? `${meta.label} · EA in conferma ${pendingAge.toFixed(0)}s`
        : meta.label}
    >
      <meta.Icon width={12} height={14} />
      {meta.label}
      {isPending && <Loader2 className="w-2.5 h-2.5 animate-spin" />}
    </span>
  )
}
